<template>
  <div v-if="loaded">
    <h2>
      Dodajte nov nivo cene:
    </h2>

    <MyCompanyBusinessUnitPricingForm
      :hidetimes="true"
      :hideDescription="true"
      newProp
      @save="save"
      @cancel="cancel"
      ref="form"
    />

    <ConfirmDialog
      ref="confirmdialogunsaved"
      title="Opozorilo"
      text="Ali želiš izhod brez shranjevanja podatkov?"
      okBtnText="Razumem"
      :normal="false"
      v-model="showWarningModal"
    />
  </div>
  <div v-else style="width: 100%">
    <AppSpinner />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MyCompanyBusinessUnitPricingForm from '@/components/MyCompanyBusinessUnitPricingForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import CurrentStockSearchForm from '@/components/CurrentStockSearchForm'
import InventoryFormArticleRow from '@/components/InventoryFormArticleRow'
import PopupArticleCard from '@/components/PopupArticleCard'

export default {
  components: {
    CurrentStockSearchForm,
    PopupArticleCard,
    InventoryFormArticleRow,
    MyCompanyBusinessUnitPricingForm,
    ConfirmDialog
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      currentStock: [],
      localEndDate: null,
      showDeleteAcceptanceFormModal: false,
      deleteAcceptanceForm: null,
      popupArticleCardArticle: null,
      localArticles: {},
      currentArticle: null,
      showWarningModal: false,
      unsavedChanges: false,
      disableLoadingBtn: false,
      is_reset: false,
      loaded: false
    }
  },
  methods: {
    ...mapActions('businessUnits', ['setBusinessUnitPricingTime']),
    save (form) {
      /* if (!this.unsavedChanges) return */
      this.showWarningModal = false
      this.setBusinessUnitPricingTime({ id: null, times: []/* this.formatDates(form.data.dates) */, name: form.data.name, is_active: form.data.is_active, decription: form.data.description })
        .then(inventoryId => {
          this.$router.push({ name: 'MyCompanyBusinessUnitPricingEdit', params: { id: inventoryId.id, newEntry: true } })
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyBusinessUnitPricing' })
    },
    formatDates (dates) {
      return dates.map(dateInfo => {
        const [_, start_month, start_day] = dateInfo.startDate.split('-')
        const [start_hour, start_minute, __] = dateInfo.startTime.split(':')
        const [___, end_month, end_day] = dateInfo.endDate.split('-')
        const [end_hour, end_minute, ____] = dateInfo.endTime.split(':')
        return {
          // ...dateInfo,
          start_month,
          start_day,
          end_month,
          end_day,
          start_hour,
          start_minute,
          end_hour,
          end_minute
        }
      })
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      this.loaded = true
      this.showWarningModal = false
      this.asyncDataStatus_fetched()
    }
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'MyCompanyBusinessUnitPricingEdit' || to.name === 'MyCompanyBusinessUnitPricing') {
      next()
    } else {
      this.showWarningModal = true
      next(await this.$refs.confirmdialogunsaved.pop())
    }
  }
}
</script>
